import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'tanok';
import {
    getRoom,
    CONTEXT_TYPE_PRODUCT,
    CONTEXT_TYPE_FILE,
} from '@evo/chat-core';

import { getSocketStore } from '../../../../../../libs/utils';

import { toJS } from '../../../../../helpers/ImmutableToJS';

import { ContextMsg } from './context';
import { FileMsg } from './file';
import { CommonMsg } from './common';


const MessageView = ({
    msg,
    intersectionObserver,
    triggerScroll,
    markMsgRead,
    retrySendMsg,
    retrySendFile,
    retrySendFileCtx
}) => {
    let MessageComp;

    switch (msg.context_item_type) {
        case CONTEXT_TYPE_PRODUCT:
            MessageComp = ContextMsg;
            break;
        case CONTEXT_TYPE_FILE:
            MessageComp = FileMsg;
            break;
        default:
            MessageComp = CommonMsg;
            break;
    }

    return (
        <MessageComp
            msgId={msg.id}
            intersectionObserver={intersectionObserver}
            markMsgRead={markMsgRead}
            retrySendMsg={retrySendMsg}
            triggerScroll={triggerScroll}
            retrySendFile={retrySendFile}
            retrySendFileCtx={retrySendFileCtx}
        />
    );
};

MessageView.propTypes = {
    msg: PropTypes.object,
    intersectionObserver: PropTypes.object,
    markMsgRead: PropTypes.func,
    retrySendMsg: PropTypes.func,
    retrySendFile: PropTypes.func,
    retrySendFileCtx: PropTypes.func,
};

const mapStateToProps = (state, ownProps) => {
    const socketStore = getSocketStore(state);
    const currentChatRoom = getRoom(socketStore, state.get('openedRoomIdent'));
    const msg = currentChatRoom.get('history').find((m) => m.get('id') === ownProps.msgId);

    return {
        locale: state.get('locale'),
        msg
    };
};

export const Message = connect(mapStateToProps)(toJS(MessageView));
